import classnames from 'classnames';
import { forwardRef } from 'react';
import { Button } from 'palette/Button';
import { BodyText, Typography } from 'palette/Typography';
import { TabProps } from './types';

import './styles/Tab.scss';

const Tab = forwardRef<HTMLButtonElement, TabProps>(({
    id,
    isDisabled,
    isSelected,
    label,
    className,
    onSelect,
    isGrid,
    variant = 'small',
    iconName = 'grid3',
    hasIndicator = false,
    theme = 'transparent',
}, ref) => {
    const classes = classnames(className, {
        [`palette-tab palette-tab__${theme}`]: theme === 'primary',
        [`palette-tab palette-tab__${variant}`]: theme !== 'primary',
        'palette-tab--selected': isSelected,
        'palette-tab--grid': isGrid,
    });

    const handleTabClick = () => {
        onSelect?.(id);
    };

    return (
        <Button
            ref={ref}
            aria-controls={`panel-${id}`}
            aria-selected={isSelected}
            className={classes}
            disabled={isDisabled}
            iconColor={isSelected ? 'black' : 'grey-300'}
            iconName={isGrid ? iconName : undefined}
            id={id}
            isTransparent={theme === 'transparent'}
            role="tab"
            size={isGrid ? 'small' : 'medium'}
            tabIndex={isSelected ? 0 : -1}
            theme={theme === 'primary' && isSelected ? 'primary' : 'secondary'}
            type="button"
            onClick={handleTabClick}
        >
            {!isGrid
                && (
                    <div className="palette-tab__custom-main-container">
                        {theme !== 'primary' ? (
                            <BodyText
                                className="palette-tab__custom-main-container__label"
                                level="1"
                                overflowType="ellipsis"
                                transform="capitalize"
                            >
                                {label}
                            </BodyText>
                        ) : (
                            <Typography
                                className="palette-tab__custom-main-container__label"
                                overflowType="ellipsis"
                                transform="uppercase"
                            >
                                {label}
                            </Typography>
                        )}
                        {hasIndicator ? (
                            <div className="palette-tab__custom-main-container__indicator" />
                        ) : null}
                    </div>
                )}
        </Button>
    );
});

Tab.displayName = 'Tab';

export default Tab;
